export default __webpack_public_path__ + "static/media/sn.3ae0146b.png";